import { StyleRules } from '@material-ui/core/styles';
import { DialogTitleClassKey } from '@material-ui/core/DialogTitle';

import { core as theme } from '../styles/core';

export const MuiDialogTitle: Partial<StyleRules<DialogTitleClassKey>> = {
  root: {
    padding: theme.spacing(3, 3, 1),
  },
};
